import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { StorageService, STORAGE_PREFIX } from './services/storage.service';
import { provideIonicAngular } from '@ionic/angular/standalone';
import { IonicModule } from '@ionic/angular';
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, provideHttpClient } from '@angular/common/http';
import { DebugLoggerService } from './services/debug-logger.service';
import { WebSocketSignalingService } from './services/websocket-signaling.service';
import { WebrtcMeshService } from './services/webrtc-mesh.service';

export function httpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideIonicAngular({
      mode: 'md'
    }),
    provideHttpClient(),
    StorageService,
    DebugLoggerService,
    WebSocketSignalingService,
    WebrtcMeshService,
    {
      provide: 'WebSocketSignalingService',
      useExisting: WebSocketSignalingService
    },
    {
      provide: STORAGE_PREFIX,
      useValue: 'events'
    },
    importProvidersFrom(
      IonicModule.forRoot(),
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: httpLoaderFactory,
          deps: [HttpClient]
        },
        defaultLanguage: 'en'
      })
    ),
  ]
}; 